

export const companyQues = [
    {
        ques: 'How would you describe the operational complexity of the company?',
        options: {
            'Low Complexity': 'Operates from a single location as a unified unit with minimal departmental divisions.',
            "Moderate Complexity": "Operates from a limited number of locations (typically 2 or 3), with several",
            "High Complexity": "Operates across multiple locations spanning diverse regions, with numerous specialized departments and divisions managing distinct functions."
        }
    },
    {
        ques: 'How would you define the decision-making and work structure at the company?',
        options: {
            'Structured': 'Follows a clear hierarchical model with distinct roles and centralized decision-making, ensuring consistency and clear communication',
            "Autonomous": "Empowers individuals to make decisions independently, fostering innovation through the freedom to act in alignment with organizational goals.",
            "Collaborative": "Emphasizes teamwork and consensus-building, with cross-functional groups working collectively to shape strategies and decisions."
        }
    },
    {
        ques: 'What is the organization’s approach to growth and change?',
        options: {
            'Systems-Driven': 'Follows established processes and standardized procedures to guide development, ensuring stability through predictable frameworks.',
            "Innovative": "Actively explores new opportunities and embraces change as a chance to evolve, even if that means disrupting existing operations.",
            "Cautious": "Carefully weighs the pros and cons before pursuing new ventures, ensuring that every change is measured against potential risks."
        }
    },
]